// extracted by mini-css-extract-plugin
module.exports = {"slider":"slider_slider__d__N0","claim":"slider_claim__AN_uW","claimArchive":"slider_claimArchive__A013H"};